import React, { useCallback, useEffect } from 'react';
import { ApplicationView } from '@aha-app/mvc';
import styles from './Modal.module.css';

interface ModalHeaderProps {
  onClose: () => void;
  children?: React.ReactNode;
  modalTitle?: string;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  onClose,
  modalTitle,
  children,
}) => {
  const modalHeaderRef = useCallback(
    (header: HTMLElement | undefined) =>
      header?.addEventListener('aha-modal-header:close', (e: Event) => {
        if (e.target === header) {
          onClose();
        }
      }),
    [onClose]
  );

  return (
    <aha-modal-header ref={modalHeaderRef} modal-title={modalTitle}>
      {children}
    </aha-modal-header>
  );
};

interface ModalProps {
  onClose?: () => void;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ onClose, children }) => {
  useEffect(() => {
    if (!onClose) return;

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        onClose?.();
      }
    }

    document.addEventListener('keydown', handleKeyDown, true);

    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [onClose]);

  return (
    <div
      popover='manual'
      ref={el => {
        el?.showPopover();
      }}
      className={styles.popover}
    >
      <div className={styles.backdrop} onClick={onClose} />
      <div className={styles.modal}>{children}</div>
    </div>
  );
};

export default ApplicationView(Modal);
